// import React from "react";
// import keyboard from "../../Assets/use-10.jpg";

// const Section1 = () => {
//   return (
//     <div className="relative  ">
//       {/* Background Image */}
//       <div className="w-full bg-[#f2efea] h-[1000px] overflow-hidden px-28 -mt-24">
//         <img
//           src={keyboard}
//           alt="Hero Section Banner"
//           className="w-full h-full object-cover brightness-50 "
//         />
//       </div>

//       {/* Zigzag Image */}
//       <div className="absolute top-[500px] left-[15%] z-20 mt-72 rotate-45">
//         <img
//           src="https://static.showit.co/400/D0hghjfYR0yp5pRJwcqjHw/51489/doodle_8.png"
//           alt="Decorative Zigzag"
//           className="w-[200px] h-auto"
//         />
//       </div>
//       {/* Text Content */}
//       <div className="absolute top-[200px] left-[65%] z-30 text-white">
//         <h4
//           className="text-xl font-thin mb-6 text-left tracking-widest"
//           style={{ fontFamily: "'theimpressionist'" }}
//         >
//           Connect Engage Grow
//         </h4>
//         <h1
//           className="text-4xl font-bold"
//           style={{ fontFamily: "'Blacker Pro Display'" }}
//         >
//           Welcome to Our Platform
//         </h1>

//         <div className="text-justify">
//           <div className="w-[450px] mt-7">
//             <p
//               className="text-white text-[17px] leading-relaxed tracking-wide"
//               style={{
//                 fontFamily: "Lato-Regular",
//               }}
//             >
//               Step into a world where possibilities are endless, and every
//               challenge sparks a new opportunity. Together, let's create a
//               future that’s bold, innovative, and uniquely yours.
//             </p>
//           </div>
//         </div>

//         {/* <button className="mt-6 px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg">
//           Get Started
//         </button>  */}
//       </div>
//     </div>
//   );
// };

// export default Section1;
import React from "react";
import keyboard from "../../Assets/use-10.jpg";

const Section1 = () => {
  return (
    <div className="relative">
      {/* Background Image */}
      <div className="w-full bg-[#f2efea] min-h-screen lg:h-[200px] overflow-hidden px-4 sm:px-8 md:px-16 lg:px-28 -mt-24">
        <img
          src={keyboard}
          alt="Hero Section Banner"
          className="w-full h-full object-cover brightness-50"
          style={{ minHeight: "100vh" }}
        />
      </div>

      {/* Zigzag Image */}
      <div className="absolute  top-[250px] left-[5%] sm:left-[10%] md:left-[15%] z-20 mt-40 sm:mt-52 md:mt-72 rotate-45 hidden sm:block  transform-gpu">
        <img
          src="https://static.showit.co/400/D0hghjfYR0yp5pRJwcqjHw/51489/doodle_8.png"
          alt="Decorative Zigzag"
          className="w-[100px] md:w-[150px] lg:w-[200px] h-auto"
        />
      </div>

      {/* Text Content */}
      <div className="absolute top-[20%] sm:top-[25%] md:top-[25%] left-[5%] sm:left-[45%] md:left-[55%] lg:left-[60%] z-30 text-white px-4 sm:px-0">
        <h4
          className="text-lg sm:text-xl font-thin mb-4 sm:mb-6 text-left tracking-widest"
          style={{ fontFamily: "'theimpressionist'" }}
        >
          Connect Engage Grow
        </h4>
        <h1
          className="text-3xl sm:text-4xl font-bold"
          style={{ fontFamily: "'Blacker Pro Display'" }}
        >
          Welcome to Our Platform
        </h1>

        <div className="text-justify">
          <div className="w-full sm:w-[350px] md:w-[400px] lg:w-[450px] mt-4 sm:mt-7">
            <p
              className="text-white text-[15px] sm:text-[17px] leading-relaxed tracking-wide"
              style={{
                fontFamily: "Lato-Regular",
              }}
            >
              Step into a world where possibilities are endless, and every
              challenge sparks a new opportunity. Together, let's create a
              future that's bold, innovative, and uniquely yours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
